import { useSelector } from 'react-redux'
import { GDP_TAB } from '../../../constant'
import { ChartIndustryGDP } from './ChartIndustryGDP'
import { ChartNominalIndustry } from './ChartNominalIndustry'
import { selectTab } from './slice'

export const Content = ({ yAxisWidth, height }) => {
  const tab = useSelector(selectTab)

  return tab === GDP_TAB.REAL_GDP.key ? (
    <ChartIndustryGDP yAxisWidth={yAxisWidth} height={height} />
  ) : (
    <ChartNominalIndustry yAxisWidth={yAxisWidth} height={height} />
  )
}
